<template>
  <LegalSiteArticle :page="contactPage" nav-page="contact" />
</template>

<script>
import LegalSiteArticle from '@/components/LegalSiteArticle.vue'
import { contactPage } from '@/data/sitePages'

export default {
  components: { LegalSiteArticle },
  data() {
    return { contactPage }
  },
}
</script>
